import React from "react";
import { Tooltip } from "antd";
import styles from "./AcquirerStatusCell.module.css";

export type AcquirerStatusView = "labels" | "dots";

interface AcquirerStatusCellProps {
  view: AcquirerStatusView;
  label: string;
  color: string;
  empty: boolean;
  tooltip?: React.ReactNode;
  actions?: React.ReactNode;
}

const CHIP: Record<string, { dot: string; bg: string; fg: string }> = {
  green: { dot: "#52c41a", bg: "#f6ffed", fg: "#389e0d" },
  red: { dot: "#ff4d4f", bg: "#fff2f0", fg: "#cf1322" },
  orange: { dot: "#fa8c16", bg: "#fff7e6", fg: "#d46b08" },
  yellow: { dot: "#fadb14", bg: "#fffbe6", fg: "#d4b106" },
  blue: { dot: "#1677ff", bg: "#e6f4ff", fg: "#1677ff" },
  gray: { dot: "#8c8c8c", bg: "#f5f5f5", fg: "#595959" },
  default: { dot: "#bfbfbf", bg: "#f5f5f5", fg: "#595959" },
  white: { dot: "#d9d9d9", bg: "#fafafa", fg: "#8c8c8c" },
};

export default function AcquirerStatusCell({
  view,
  label,
  color,
  empty,
  tooltip,
  actions,
}: AcquirerStatusCellProps) {
  const chip = CHIP[color] ?? CHIP.default;

  if (view === "dots") {
    const dot = empty ? (
      <span className={styles.dash}>—</span>
    ) : (
      <span className={styles.dot} style={{ background: chip.dot }} />
    );
    return tooltip ? <Tooltip title={tooltip}>{dot}</Tooltip> : dot;
  }

  if (empty && !label) {
    return <span className={styles.dash}>—</span>;
  }

  const isPendingSubmission = label === "Pending Submission";
  const tag = (
    <span
      className={`${styles.chip} ${
        isPendingSubmission ? styles.chip_pending : ""
      }`}
      style={{ background: chip.bg, color: chip.fg }}
    >
      <span className={styles.dot} style={{ background: chip.dot }} />
      <span className={styles.chip_label}>{label}</span>
    </span>
  );

  return (
    <span className={styles.labels}>
      {tooltip ? <Tooltip title={tooltip}>{tag}</Tooltip> : tag}
      {actions}
    </span>
  );
}
